import { Divider, Heading, VStack } from '@chakra-ui/react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type DealTermsProps = {
  children?: React.ReactNode;
};

export const DealTerms: React.FC<DealTermsProps> = () => {
  const { property } = usePropertiesModel();
  const dealTerms = [
    { description: currency.format(property?.target_amount ?? 0), title: 'Total Raise Amount' },
    { description: currency.format(property?.min_invest_amount ?? 0), title: 'Minimum Investment Size' },
    { description: `${property?.leverage_pct}%`, title: 'Leverage' },
    { description: `${property?.expected_return}%`, title: 'Hypothetical 1-Year Return' },
  ];
  return (
    <VStack alignItems={'flex-start'} w="full">
      <Heading fontFamily={FontFamily.HELVETICA_NOW_BOLD} fontWeight="normal" fontSize={['32px', '40px']}>
        Deal Terms
      </Heading>
      <VStack alignItems="flex-start" w="full">
        {dealTerms.map((item) => (
          <VStack key={item.title} alignItems="flex-start" w="full" gap="0px" style={{ paddingTop: 20 }}>
            <TextBlock color={'gray.300'} lineHeight="19px">
              {item.title}
            </TextBlock>
            <TextBlock weight="bold" fontSize="24px" lineHeight={'29px'}>
              {item.description}
            </TextBlock>
            <Divider color="gray.100" paddingBottom="20px" />
          </VStack>
        ))}
      </VStack>
    </VStack>
  );
};
